module.exports = __webpack_public_path__ + "media/images/flags/zw-f5ceeff7d65d0b5e33b79719b9948b59.svg";